import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'Waiting for<br />Confirmation and Execution',
    description:
      'Ask the co-owners to confirm the pending transaction inside the <b>Safe App</b>.\n' +
      'They can review and sign it under <b>Transactions → Queue</b> in their Safe Wallet.',
    additional:
      'Once the required number of confirmations (the quorum) has been collected, any one of the owners can <b>Execute</b> the transaction directly in the <b>Safe Wallet</b>.',
    ok: 'Ok',
  },
};
